import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
	CssBaseline,
	Grid,
	Button,
	Typography
} from '@material-ui/core'
import Logo from '../../assets/cbc_logo.svg';

interface Props {
	login: () => void
}

/*
* component defs
*/

/**
 * **Login component**
 * 
 * If the user is not logged in, displays the ms login button and validates against the login function passed in to the component
 * 
 * @param login login function 
 */

function LoginPage({ login }: Props) {
	const classes = useStyles();

	return (
		<React.Fragment>
			<CssBaseline />
			<Grid item container spacing={2} justify="center" alignItems="center" direction="column">
				<Grid className={classes.logo} item><img width="320" src={Logo} alt="cbcity logo" /></Grid>
				<Grid item>
					<Typography align='center'>Sign in with your CBCity ID to get started</Typography>
				</Grid>
				<Grid item className={classes.button}>
					<Button onClick={login} size="large" type="submit" variant="contained" color="primary">
						Sign in with CBCity ID
					</Button>
				</Grid>
			</Grid>
		</React.Fragment>
	);
}

/*
* styles
*/

const useStyles = makeStyles((theme) => ({
	root: {

	},
	input: {
		width: "20rem"
	},
	logo: {
		marginBottom: theme.spacing(4)
	},
	button: {
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(8)
	}

}));

export default LoginPage;
